import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import OcrIngestionsContainer from '../../containers/ocr/OcrIngestions';
import AuthUserContainer from '../../containers/AuthUser';
import ResourcePopup from '../../components/Dialogs/ResourcePopup';
import OcrDocumentUploadDialog from '../../components/Dialogs/OcrDocumentUploadDialog';
import InvoicePdfPopup from '../../components/Dialogs/InvoicePdfPopup';
//import PricingPopupIcon from "../../images/icons/pricingPopup.svg";
//import documentIcon from "../../images/document.svg";

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import Button from '@material-ui/core/Button';
import { CircularProgress, Typography } from '@material-ui/core';

import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';
import invoiceIcon from '../../images/invoicePdf.svg';
import { renderOcrIngestionDocs } from './helper';

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

const ocrColumns = [
	{
		sortId: 'ocrIngestionId',
		displayId: 'ocrIngestionId',
		labels: ['Ingestion ID'],
	},
	/*
	{
		sortId: 'accountingCategory',
		displayId: 'accountingCategory',
		labels: ['Type'],
	},
	*/
	{
		sortId: 'dateCreated',
		displayId: 'dateCreatedFormatted',
		label: 'Date Uploaded',
	},
	{
		noSort: true,
		sortId: 'documentResourceId',
		displayId: 'originalDocumentDisplay',
		label: 'Original PDF',
	},
	{
		sortId: 'ingestionStatus',
		displayId: 'ingestionStatusDisplay',
		label: 'OCR Progress',
	},
	{
		sortId: 'documentInfo',
		displayId: 'documentsDisplay',
		label: 'Matched Documents',
	},
	{
		sortId: 'isUploadingRackTransfer',
		displayId: 'uploadTypeDisplay',
		label: 'Upload Type',
	},
	{
		sortId: 'ocrIngestionResultIds',
		displayId: 'ocrIngestionResultIdsDisplay',
		label: 'Results Created',
	},
];

class OcrIngestions extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'current');
		const startingTabIndex = { current: 0, upcoming: 1, completed: 2 }[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			order: 'desc',
			orderBy: 'ocrIngestionId',
			search: '',
			filterMap: {},
			isViewDialogOpen: false,
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
			isPricingPoppedUp: false,
			ocrIngestionPoppedUp: undefined,

			upcomingRows: undefined,
			currentRows: undefined,
			completedRows: undefined,
			isUploadOpen: false,
			isUploadingRackTransfer: false,

			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,
		};
	}

	componentDidMount() {
		const { ocrIngestions, ocrIngestionSearch } = this.props;

		if (!ocrIngestions) {
			ocrIngestionSearch({ doNotIncludeOcrBlocks: true });
		} else {
			this.formatOcrIngestions();
		}
	}

	componentDidUpdate(prevProps) {
		const { ocrIngestions } = this.props;
		if (prevProps.ocrIngestions !== ocrIngestions) {
			this.formatOcrIngestions();
		}
	}
	refreshTable = () => {
		const { ocrIngestionSearch } = this.props;
		this.setState({ formattedOcrIngestions: undefined });
		ocrIngestionSearch({ doNotIncludeOcrBlocks: true });
	};

	onInvoiceClick = (resourceId) => {
		this.setState({
			isInvoicePdfPopupOpen: true,
			invoicePdfPoppedUp: resourceId,
		});
	};

	handleCloseInvoicePdfPopup = () => {
		this.setState({
			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,
		});
	};

	formatOcrIngestions = () => {
		const { classes } = this.props;
		const { ocrIngestions, ocrIngestionDocumentMap, ocrGuideMap } = this.props;
		const formattedOcrIngestions = [];
		ocrIngestions.forEach((ocrIngestion) => {
			const {
				ocrIngestionId,
				ocrIngestionDocumentIds,
				documentResourceId,
				dateCreated,
				ingestionStatus,
				ingestionStatusMessage,
				ocrIngestionResultIds = [],
				isUploadingRackTransfer,
			} = ocrIngestion;

			ocrIngestion.key = ocrIngestionId;
			ocrIngestion.ocrIngestionResultIdsDisplay = ocrIngestionResultIds.join(', ');
			ocrIngestion.uploadTypeDisplay = isUploadingRackTransfer ? 'Rack Transfer' : 'Invoice Upload';
			ocrIngestion.dateCreatedFormatted = (
				<div>
					<div>{moment(dateCreated).format('M/D/YYYY')}</div>
				</div>
			);

			if (ingestionStatus === 'complete') {
				ocrIngestion.ingestionStatusDisplay = (
					<>
						<span className={classes.greenCheckedIconSmall} /> Complete
					</>
				);
			} else if (ingestionStatus === 'error') {
				ocrIngestion.ingestionStatusDisplay = (
					<>
						<div>
							<span className={classes.errorIconSmall} /> Error
						</div>
						<div>{ingestionStatusMessage}</div>
					</>
				);
			} else {
				ocrIngestion.ingestionStatusDisplay = (
					<>
						<CircularProgress size="14px" style={{ marginRight: 4 }} />
						{_.startCase(ingestionStatus)}
					</>
				);
			}

			ocrIngestion.originalDocumentDisplay = (
				<div
					className={classes.invoiceIcon}
					onClick={() => {
						this.onInvoiceClick(documentResourceId);
					}}
				/>
			);

			const ocrIngestionDocuments = _.sortBy(
				ocrIngestionDocumentIds.map((ocrIngestionDocumentId) => {
					return ocrIngestionDocumentMap[ocrIngestionDocumentId] || null;
				}),
				'pageNumber'
			);

			if (_.isEmpty(ocrIngestionDocuments)) {
				ocrIngestion.documentsDisplay = '-';
			} else {
				ocrIngestion.documentsDisplay = renderOcrIngestionDocs({
					ocrIngestionDocuments,
					ocrGuideMap,
				});
			}

			ocrIngestion.triageButtons = (
				<Button className={classes.button} onClick={() => this.handleTriage(ocrIngestionId)}>
					Triage
				</Button>
			);

			formattedOcrIngestions.push(ocrIngestion);
		});
		this.setState({ formattedOcrIngestions });
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleTriage = (ocrIngestionId) => {
		this.props.history.push(`/ocr/ocrIngestion/triage/${ocrIngestionId}`);
	};

	handleRowClick = (ocrIngestionId) => {
		const { ocrIngestions } = this.props;
		const viewFuelContract = _.find(ocrIngestions, { ocrIngestionId });
		this.setState({
			viewFuelContract,
			isViewDialogOpen: true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewFuelContract: undefined,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	showInvoiceDocumentUpload = () => {
		this.setState({ isUploadOpen: true, isUploadingRackTransfer: false });
	};

	showRackTransferDocumentUpload = () => {
		this.setState({
			isUploadingRackTransfer: true,
			isUploadOpen: true,
		});
	};
	handleCloseUploadDialog = () => {
		this.setState({
			isUploadingRackTransfer: false,
			isUploadOpen: false,
		});
	};

	render() {
		const { classes, resourceMap } = this.props;
		const { formattedOcrIngestions, order, orderBy } = this.state;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={4}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>OCR Ingestions</span>
							</Typography>
						</Grid>

						<Grid item xs={8} style={{ textAlign: 'right' }}>
							<Button
								variant="outlined"
								color="primary"
								className={classes.addButton}
								onClick={this.refreshTable}
								style={{ marginRight: 10 }}
							>
								Refresh Table
							</Button>
							<Button
								variant="contained"
								color="primary"
								className={classes.addButton}
								onClick={this.showInvoiceDocumentUpload}
								style={{ marginRight: 10 }}
							>
								Upload Invoice Docs
							</Button>

							<Button
								variant="contained"
								color="primary"
								className={classes.addButton}
								onClick={this.showRackTransferDocumentUpload}
							>
								Upload Rack Transfer Docs
							</Button>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						{!formattedOcrIngestions && <div>Loading the ocr ingestions...</div>}
						{formattedOcrIngestions && (
							<EnhancedTable
								columns={ocrColumns}
								rows={formattedOcrIngestions}
								defaultOrder={order}
								defaultOrderBy={orderBy}
							/>
						)}
						<ResourcePopup
							open={this.state.isResourcePopupOpen}
							onClose={this.handleCloseResourcePopup}
							resourceIds={this.state.resourceIdsPoppedUp}
							resourceMap={resourceMap}
						/>
						<OcrDocumentUploadDialog
							open={this.state.isUploadOpen}
							isUploadingRackTransfer={this.state.isUploadingRackTransfer}
							onClose={this.handleCloseUploadDialog}
							showErrors={this.props.showErrors}
							history={this.props.history}
							onAfterSave={this.refreshTable}
						/>

						<InvoicePdfPopup
							open={this.state.isInvoicePdfPopupOpen}
							onClose={this.handleCloseInvoicePdfPopup}
							resourceId={this.state.invoicePdfPoppedUp}
							resourceMap={resourceMap}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

OcrIngestions.propTypes = {
	classes: PropTypes.object.isRequired,
	ocrIngestionSearch: PropTypes.func.isRequired,
	ocrIngestions: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	ocrIngestionDocumentMap: PropTypes.object,
	resourceMap: PropTypes.object,
	ocrGuideMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,

	authUser: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	OcrIngestionsContainer,
])(OcrIngestions);
